import type { Listener } from 'history';

import { NAMESPACE } from '../../config/app.constants';

import { Locale } from '../Intl';
import { BrowserRouter } from '../BrowserRouter';
import { Provider as LoggerProvider } from '../Logger';
function EntryPoint({
  children,
  locale,
  historyListeners,
}: {
  children: JSX.Element | (JSX.Element | null)[];
  locale?: string;
  historyListeners?: Listener[];
}) {
  return (
    <LoggerProvider namespace={NAMESPACE}>
      <Locale.Provider locale={locale}>
        <BrowserRouter listeners={historyListeners || []}>{children}</BrowserRouter>
      </Locale.Provider>
    </LoggerProvider>
  );
}

export default EntryPoint;
